export enum SBARows {
    LineOfCredit = 'Line of Credit',
}
